<!-- hmqm-出厂报告模板-详情+审核 -->
<template>
    <h-inspection-page :title="h_i18n('ec006c91b72265f9e0381115b71dfe72')" @inspection-update="inspectionUpdate">
      <template #hands>
        <span style="margin-right: 12px;background-color: #E8F3FF;padding: 5px 6px;">{{ planeDetails.versionNo || '' }}</span>
        <h-button type="primary" @click="synchronizeData">{{ h_i18n('a1c90d3995ef66764d6a0734ddc21309') }}</h-button>
        <!-- <h-button @click="ceshi">测试查询</h-button> -->
      </template>
      <inspection-header :title="h_i18n('ec006c91b72265f9e0381115b71dfe72')" title-height="80px">
  
        <template #body>
          <tr style="border: none;">
          <td colspan="6" style="border: none;">
            <div class="factory_item">
              <div class="nav_th50">
                <div class="nav_left_befor">{{ h_i18n('fd5b64ec505f303e7c052ce0d5690b21') }}</div>
                <div class="nav_right">{{ planeDetails.mtlNo }}</div>
              </div>
              <div class="nav_th50">
                <div class="nav_left">{{ h_i18n('d3d82d46881ddede6be88387fa1ecea0') }}</div>
                <div class="nav_right">{{ planeDetails.mtlName }}</div>
              </div>
            </div>
          </td>
        </tr>
        </template>
      </inspection-header>
      <inspection-body>
        <div>

        </div>
        <vxe-table border :row-config="{ isHover: true, height: 35 }" :cell-class-name="colorBack"
          :scroll-y="{ mode: 'default', gt: 50 }" min-height="600" style="width: 100%;margin-top: 5px;"
          :align="left"
          :data="tableList" :span-method="arraySpanMethod" >
          <vxe-column :title="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" type="seq" width="50" show-overflow fixed="left">
            <template #default="{ row }">
              <template v-if="row.frontKey == 'OTHER'">
                <div style="float:left;text-align: left;height: 36px;display: flex;align-items: center">{{ h_i18n('7e217ea649098e03f615a99ae9c692a8') }}<span style="color: #165DFF;">{{ row.templateCode }}</span>{{ h_i18n('6d2c01ad47709bd98fbc4dbbcea7c841') }}<span style="color: #165DFF;">{{ row.templateName }}</span> 
              </div>
              </template>
              <template v-else-if="row.frontKey == 'OTHERT'">
                <div style="float:left;text-align: left;height: 36px;display: flex;align-items: center">
                  <span style="color: #165DFF;">{{ row.templateName }}</span> 
                </div>
              </template>
              <template v-else>
                <div>
                  {{ row.frontIndex }}
                </div>
              </template>
            </template>
          </vxe-column>
          <vxe-column :title="h_i18n('222c0f1a6341c9df01ca58fc982db93b')" field="itemName" width="200" show-overflow></vxe-column>
          <vxe-column :title="h_i18n('afb44627fabcf435b4633f1f6bd12eb3')" field="remark" ></vxe-column>
          <!-- <vxe-column title="重要性" width="100" field="importancePropertyName" show-overflow></vxe-column>
          <vxe-column title="检查水平" width="100" field="checkLevelName" show-overflow></vxe-column> -->
          <vxe-column :title="h_i18n('4626e7457839719f5fa1b08526e5e3fd')" width="100" show-overflow>

<template #default="{ row }">
    <el-select v-model="row.importanceProperty" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" disabled>
      <el-option v-for="item in importantList" :key="item.valueId"
        :label="item.valueName ? item.valueName : ' '" :value="item.valueId.toString()"></el-option>
    </el-select>
</template>
</vxe-column>
<!-- <vxe-column title="重要性" width="100" title-help>
  <template #default="{ row }">
      <el-select v-model="row.importanceProperty" placeholder="请选择">
        <el-option v-for="item in importantList" :key="item.valueId"
          :label="item.valueName ? item.valueName : ' '" :value="Number(item.valueId)">
        </el-option>
      </el-select>
  </template>
</vxe-column> -->
<vxe-column :title="h_i18n('0cf684d33849528278363c0e3991cb82')" width="100" show-overflow>
<template #default="{ row }">
    <el-select v-model="row.checkLevel" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" disabled>
      <el-option v-for="item in checkLevelList" :key="item.valueId"
        :label="item.valueName ? item.valueName : ' '" :value="item.valueId.toString()"></el-option>
    </el-select>
</template>
</vxe-column>
          <vxe-column title="AQL" width="100" field="aqlProperty"></vxe-column>
        </vxe-table>
      </inspection-body>
      <inspection-footer>
  
        <template #body>
          <tr>
            <h-td :title="h_i18n('97d7e7ac40b2a31b9cdbde20c724114b')" colspan="10" style="height: 100px;">
              <div>
                <p style="text-align: left;text-indent: 4ch;white-space: normal;">{{ h_i18n('bb75f437133fb1fa63331cc8f0a58eed') }}</p>
                <p style="text-align: left;text-indent: 4ch;white-space: normal;">{{ h_i18n('ad0ca85cdefc015f7357765e030a2c9d') }}</p>
                <el-checkbox style="text-align: center;width: 100%;" v-model="haseRead" disabled label="1">{{ h_i18n('ee1dfef67afe79135693b84b74f6185e') }}</el-checkbox>
              </div>
            </h-td>
          </tr>
          <tr style="height: 100px;" v-if="$route.query.type==2" >
          <h-td colspan="5" :title="h_i18n('ab1bcd732b932ead763bf080d90e93ab')">
            <el-input type="textarea" style="height: 90px;" :rows="5" class="input_rows_style" size="large"
               :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')"
              v-model="auditOpinion" maxlength="200" show-word-limit>
            </el-input>
          </h-td>
        </tr>
        <tr  v-else>
          <h-td colspan="5" title="审核意见">
            {{ planeDetails.auditOpinion }}
          </h-td>
        </tr>
        </template>
  
        <template #footer>
          <h-button-group align="center">
            <h-button type="primary" size="big" v-if="$route.query.type==2" @click="submit(1)">{{ h_i18n('e61f2cc4c39244f627b20e18788c3890') }}</h-button>
            <h-button type="primary" size="big" v-if="$route.query.type==2" @click="submit(2)">{{ h_i18n('1bf19c1953d1351b341497c74715e83c') }}</h-button>
            <h-button size="big" @click="backOrClose()">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
          </h-button-group>
        </template>
      </inspection-footer>
    </h-inspection-page>
  </template>
  
  
  
  
  
  
  
  
  <script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  export default {
    name: 'TemplateAddTemplate',
    data() {
      return {
        planeDetails: {},//基本数据
        tableList: [],
        importantList: [],
        checkLevelList: [],
        templateCardLength: 0,
        addVisible: false,
        dialogTableList: [],
        templateCode: '',
        templateItem: '',
        auditOpinion:'',//审核意见
        haseRead:true,
      }
    },
    methods: {
    h_i18n,
      submit(v){
        if(!this.auditOpinion){
          this.info(h_i18n('e08e608c9408e404b78b9baa03d0adf9'))
          return
        }
        this.$http({
          method: "post",
          url: '/base/baseShipmentTemplate/audit',
          data:{
            "shipmentId": this.planeDetails.shipmentId,
            "status": v===1?"Y": "N", 
            "auditOpinion":this.auditOpinion,
            "name": this.$route.query.name,
            "nickName": this.$route.query.nickName
          }
        }).then(res => {
          console.log(res, '审核提交')
          if(res.data.success){
            // this.success('提交成功')
            this.success(h_i18n('23b62e9cbc868e024b80d2e3fad80ac7'), {
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
              callback: (action) => {
                // window.history.go(-1)
              },
            });
            // this.$router.back()
            this.backOrClose()
          }else{
            this.error(res.data.msg)
          }
          // this.getMtlList();
        })
      },
      synchronizeData() {
        this.$router.push({
                name: "FactoryTemplateSqmTemplateHistory",
                query: {
                    name: this.$route.query.name,
                    nickName: this.$route.query.nickName,
                    mtlNo:this.planeDetails.mtlNo,
                    dataFrom:this.$route.query.dataFrom ,
                    supplyCode:this.$route.query.supplyCode,
                },
            });
      },
      addTemplateCard() {
        this.addVisible = true
      },
      //数据查询
      getMtlList() {
        this.$http({
          url: '/base/baseShipmentTemplate/tempInfo?mtlNo=' + this.planeDetails.mtlNo+'&supplyCode='+ this.$route.query.supplyCode + '&version=' + this.planeDetails.versionNo,
          method: "get",
        }).then((res) => {
          console.log(res, '企标列表')
          this.closeLoading()
          if (res.data.success) {
            let qbList = res.data.data
            this.templateCardLength = qbList.length
            let newList = []
            for (let i = 0; i < qbList.length; i++) {
              let obj = {
                templateCode: qbList[i].templateCode,
                templateId: qbList[i].templateId,
                templateName: qbList[i].templateName,
                templateType: qbList[i].templateType,
                frontKey: 'OTHER'
              }
              newList.push(obj)
              qbList[i].itemList.map((item, index) => {
                let v = item
                v.frontIndex = index + 1
                v.templateName = qbList[i].templateName
                v.frontKey = 'ITEM'
                newList.push(v)
              })
            }
  
            console.log(newList, 'end01')
            this.getComList(newList)
          } else {
            this.info(res.data.msg)
          }
        })
      },
      getComList(list) {
        this.$http({
          url: '/base/baseShipmentTemplate/commonInfo?mtlNo=' +this.planeDetails.mtlNo+'&supplyCode='+ this.$route.query.supplyCode + '&version=' + this.planeDetails.versionNo,
          method: "get",
        }).then((res) => {
          console.log(res, '通用要求列表')
          let endList = list
          if (res.data.success) {
            let obj = {
              templateCode: '',
              templateId: '',
              templateName: h_i18n('09334806287d60f5b2bb2a3719f30fa8'),
              templateType: '',
              frontKey: 'OTHERT'
            }
            endList.push(obj)
            res.data.data.map((item, index) => {
              let v = item
              v.templateName = h_i18n('09334806287d60f5b2bb2a3719f30fa8')
              v.frontIndex = index + 1
              v.frontKey = 'ITEM'
              endList.push(v)
            })
            endList.map((item, index) => {
              endList[index].frontIndexItem = index
            })
            console.log(endList, 'endlist-----')
            this.tableList = endList
          }
          this.closeLoading()
        })
      },
      inspectionUpdate() {
        this.postThisPageHeight()
      },
      arraySpanMethod(data) {
        if (data.row.frontKey === "OTHER" || data.row.frontKey === "OTHERT") {
  
          return { rowspan: 1, colspan: 6 }
        }
      },
    //   arraySpanMethod(data) {
    //   if (data.row.frontKey === "OTHER") {
    //     if (data.$columnIndex === 0) {
    //       return { rowspan: 1, colspan: 0 }
    //     }
    //     if (data.$columnIndex > 1) {
    //       return { rowspan: 1, colspan: 0 }
    //     }
    //   } else {
    //     if (data.$columnIndex === 10) {
    //       return { rowspan: 1, colspan: 13 }
    //     }
    //     if (data.$columnIndex >= 11 && data.$columnIndex <= 22) {
    //       return { rowspan: 0, colspan: 1 }
    //     }
    //   }
    // },
      searchByValueTypeId(id) {
        this.$http({
          method: "get",
          url: '/base/basicData/listBaseValues?valueTypeId=' + id,
        }).then(res => {
          console.log(res.data.data, id, '14检查水平，13重要性')
          if (id == 13) {
            this.importantList = res.data.data
          }
          if (id == 14) {
            this.checkLevelList = res.data.data
            console.log(this.checkLevelList)
          }
          // this.getMtlList();
        })
      },
      backOrClose() {
        if(this.$route.query.backUrl && this.$route.query.backUrl=== 'closePage'){
          window.close()
          // 兜底：close 失败时跳回首页或指定页
          setTimeout(() => {
            // window.close() 仍会执行到这里，说明没关成功
            this.$router.replace('/')
          }, 200)
        }else{
          this.$router.back();
        }
      }
    },
    created() {
        this.planeDetails = JSON.parse(this.$route.query.data)
    },
    mounted() {
      this.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      this.searchByValueTypeId(13)
      this.searchByValueTypeId(14)
      
      if(this.planeDetails.versionNo){
        this.getMtlList();
      }else {
        this.$http({
          url:'/base/baseShipmentTemplate/mklInfo?mtlNo=' + this.$route.query.mtlNo +'&supplyCode='+ this.$route.query.supplyCode,
          method:'get',
        }).then(res=>{
          if(res.data.success && res.data.data){
            this.planeDetails.versionNo = this.planeDetails.version = res.data.data.version
            this.getMtlList();
          }else{
          }
        }).catch(err=>{

        })
      }
      // this.getComList()
      setTimeout(() => {
        this.inspectionUpdate()
      }, 1000);
    },
  }
  </script>

<style src="@/assets/css/new.scss" lang="scss"></style>

<style lang="scss">
  .vxe-body--row{
    color: #1D2129 !important;
}
.el-input__inner{
    color: #1D2129 !important;
}
.haier-td {
    color: #1D2129 !important;
}
  .h-hwork-body{
    margin-top: 0 !important;
    padding:16px !important;
  }
  .haier-td{
    border-right: none !important;
  }
  .haier-inspection-header .haier-table td{
    border-right: none  !important;
  }
  .h-work-inspection-table{
    padding: 0 !important;
  }
  .haier-title-lable{
    margin-bottom: 12px !important;
  }
  .factory_item {
  font-size: 14px;
  display: flex;
  width: 100%;
  background-color: #fff;
  line-height: 40px;
  height: 40px;

  .nav_th33 {
    display: flex;
    width: 33%;
  }
  .nav_th50 {
    display: flex;
    width: 50%;
  }
  .nav_left {
   
    color: #4E5969;
    text-align: left;
  }

  .nav_left_befor {
    color: #4E5969;
    margin-left: 16px;
  }

  .nav_right {
    color: #1D2129;
    text-align: left;
    text-indent: 12px;
  }

  .nav_flex {
    display: flex;
  }
}
  .haier-table-header--logo{
  width: 90px !important;
  height: 34px !important;
  margin-left: 17px;
  img{
    width: 90px !important;
  }
}
.vxe-cell{
  height: auto !important;
  max-height: unset !important;
}
.vxe-table{
.vxe-cell{
  text-align: left !important;
}
  .vxe-table--body-wrapper{
    overflow-x: hidden !important;
  }
  .vxe-header--column{
    font-weight: normal !important;
    color: #1D2129;
  }
  .vxe-header--row{
    height: 48px !important;
    font-size: 14px;
    border-radius: 8px 8px 0px 0px !important;
    background: rgb(241, 242, 248) !important;
  }
}
.haier-table-header--content{
  height: 56px !important;
  .haier-table-header--left{
    font-size: 24px !important;
    color: #1D2129;
    font-weight: normal !important;
  }
}
  :deep(.haier-table-header--right) {
    display: none !important;
  }
  :deep(.vxe-header--row){
    .col_4{
      width: calc(100% - 400px);
    }
  }
  .vxe-table{
    .vxe-table--body-wrapper{
      overflow-x: hidden !important;
    }
  }
  .haier-table-header--right {
    display: none !important;
  }
  .haier-table{
    border: none !important;
    .haier-table-header{
      tr{
        td{
          .haier-table-header--right{
            display: none !important;
          }
        }
      }
    }
  }

  .template_dialog {
    .dialog_search {
      height: 40px;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      margin-left: 5%;
  
      .dialog_input {
        width: 200px !important;
        margin: 0 20px !important;
      }
    }
  
    .dialog_center {
      .cen_nav {
        width: 90%;
        height: 40px;
        display: flex;
        align-items: center;
        text-align: center;
        margin-left: 5%;
        background-color: #ddedfe;
  
        div {
          width: 50%;
          height: 100%;
          border: 1px solid #ccc;
          line-height: 40px;
  
        }
      }
  
      .dialog_table {
        width: 90%;
        margin-left: 5%;
        border-bottom: 1px solid #ccc;
        max-height: 330px;
        overflow-y: auto;
        margin-bottom: 20px;
  
        .nodata {
          height: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-left: 1px solid #ccc;
          border-right: 1px solid #ccc;
        }
  
        .item {
          height: 30px;
          line-height: 30px;
          border: 1px solid #ccc;
          border-bottom: none;
          cursor: pointer;
          display: flex;
          text-indent: 20px;
  
          .item_code {
            width: 50%;
          }
  
          .item_name {
            width: 50%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
  
        .item:hover {
          background-color: #ddedfe;
        }
      }
  
      .nomes {
        margin-left: 5%;
      }
    }
  
    .dialog_footer {
      margin-left: 5%;
    }
  }
  
  body {
    overflow: auto !important
  }
  
  .haier-inspection-header .haier-table .haier-table-header .haier-table-header--right {
    width: 0 !important;
  }
  
  .el-textarea__inner {
    height: 90px !important;
  }
  
  .haier-td {
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    text-align: left;
    padding: 4px 10px;
    font-size: 14px;
    height: 35px;
    color: #666;
  }
  
  .is-right {
    text-align: right;
  }
  </style>

<style lang="scss" scoped>
  .input_13 {
    flex: none;
    width: 38px !important;
    transition: all 200ms ease-in-out;
  }
  
  .h-global-font-blue-disabled {
    color: #b6d5ff;
    cursor: not-allowed;
  }
  
  .check_true {
    width: 200px !important;
    flex: none;
  }
  </style>